"use strict";
exports.__esModule = true;
exports.chart_color_black_100 = {
  "name": "--pf-v5-chart-color-black-100",
  "value": "#f0f0f0",
  "var": "var(--pf-v5-chart-color-black-100, #f0f0f0)"
};
exports["default"] = exports.chart_color_black_100;